import { memo, useCallback } from 'react';
import { Pressable, Image, Text, StyleSheet } from 'react-native';
import { THEME, COLOR, __WEB__ } from '../../constants/styles';
import { Navigation, I18n } from '../components';

export default memo(function InviteButton(props) {
  const openInvitesModal = useCallback(() => {
    Navigation.showModal({
      screen: 'Invite',
      title: I18n.ac('invite.invitePeople'),
    });
  }, []);

  const disabled = !props.enabled;
  return (
    <Pressable
      style={[styles.button, props.buttonStyles]}
      onPress={openInvitesModal}
      disabled={!!disabled}
    >
      <Image
        style={[styles.icon, disabled ? THEME.disabled : null]}
        source={require('../../../resources/icon-invite.png')}
        resizeMode="contain"
      />
      {!!props.label && (
        <Text style={[THEME.textMedium, styles.labelStyle, disabled ? THEME.disabled : null]}>
          {props.label}
        </Text>
      )}
    </Pressable>
  );
});

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
  },
  icon: {
    width: 35,
    height: 35,
    tintColor: COLOR.text,
  },
  labelStyle: {
    marginLeft: 15,
  },
});
